




























































































































import { Vue, Component, Emit, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue'; // 导入分页组件
import { TableStripe } from '@/mixins/tableStripe';
import PublicPage from '@/views/doublePrevention/riskControlList/publicPage.vue';
import DetailPage from '@/views/doublePrevention/riskControlList/detailPage.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition';
import { companyServer, dictServe, doublePrevention, regionServe, spaceServe } from '@/api/installServer';
import { arrayToTree } from '@/util/array';
import publishObjectPath from '@/util/configRegistry';
import ImportDialogData from '@/views/doublePrevention/riskControlList/importDialogData.vue';
import Axios from 'axios';

@Component({
  components: { PagingUnit, PublicPage, DetailPage, CollapseTransition, ImportDialogData },
  mixins: [TableStripe],
})
export default class RiskControlList extends Vue {
  private showPublicPage = 'list';
  private rowData: any = {};
  private searchForm: any = {
    riskPoint: '', // 风险点
    riskTypeTagName: '', // 风险类型
    injuryDeg: '', // 伤害程度
    managementLevel: '', // 管控层级
    searchLabel: '', // 模糊搜索
    spaceArea: '', // 区域搜索
    riskLevel: '', // 风险等级
    search: '', // 关键字搜索
  };
  private tableLoading = false; // loading...
  spaceAreaList: any = []; // 区域下拉
  riskPointList: any = []; // 风险点下拉
  dangerSourceIdList: any = []; // 危险源下拉
  helpDangerSourceIdList: any = []; // 存放所有type是危险源的下拉
  controlHierarchyList: any = []; // 管控层级
  private tableData: any = [];
  private queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  private total = 0;
  private riskLevelOptions = [
    {
      label: '重大风险',
      value: '重大风险',
    },
    {
      label: '较大风险',
      value: '较大风险',
    },
    {
      label: '一般风险',
      value: '一般风险',
    },
    {
      label: '低风险',
      value: '低风险',
    },
  ];
  private uploadUrl: any = publishObjectPath.serverUrl + '/api/yunnan/riskControlInventory/canBeImported/export/excel/after/toLead';
  headers: any = {};
  fileList: any = [];

  private selectedData: any = [];

  private userInfo: any = {};

  private jumpToPublicPage(type: any, data: any) {
    this.rowData = {
      id: data ? data.id : '',
      type,
    };
    if (type === 'delete') {
      this.deleteRiskControlInventory(data.id);
    } else {
      this.showPublicPage = 'update';
    }
  }

  private jumpToDetailPage(data: any) {
    this.rowData = {
      id: data.id,
    };
    this.showPublicPage = 'detail';
  }

  // 删除
  private deleteRiskControlInventory(id: any) {
    this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        doublePrevention.deleteRiskControlInventory(id).then((res: any) => {
          if (res.code === '200') {
            this.$message.success('删除成功');
            this.getTableData();
          } else {
            this.$message.warning(res.msg);
          }
        });
      })
      .catch(() => {
        this.$message.info('已取消删除');
      });
  }

  private backToRiskPage() {
    this.showPublicPage = 'list';
    this.getTableData();
  }

  private onSearch() {
    console.log(this.searchForm);
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private onReset() {
    this.searchForm = {
      spaceArea: this.userInfo.areaId,
      riskPoint: '',
      dangerSource: '',
      riskTypeTagName: '',
      controlHierarchy: '',
      riskType: '',
      injuryDeg: '',
      managementLevel: '',
      search: '',
    };
    this.queryDataForm = {
      pageNo: 1,
      pageSize: 10,
    };
    this.getTableData();
  }

  private getListData() {
    this.getTableData();
  }

  private getTableData() {
    this.tableLoading = true;
    doublePrevention
      .getRiskControlInventory({
        current: this.queryDataForm.pageNo,
        size: this.queryDataForm.pageSize,
        riskTypeTagName: this.searchForm.riskTypeTagName ? this.searchForm.riskTypeTagName : null, // 风险类型
        controlHierarchy: this.searchForm.controlHierarchy ? this.searchForm.controlHierarchy : null, // 管控层级
        dangerSourceId: this.searchForm.dangerSource ? this.searchForm.dangerSource : null, // 危险源
        riskPointId: this.searchForm.riskPoint ? this.searchForm.riskPoint : null, // 风险点
        areaId: this.searchForm.spaceArea ? this.searchForm.spaceArea : null, // 区域
        riskLevel: this.searchForm.riskLevel ? this.searchForm.riskLevel : null, // 风险等级
        search: this.searchForm.search ? this.searchForm.search : null, // 关键字搜索
      })
      .then((res: any) => {
        this.tableLoading = false;
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
        } else {
          this.$message.warning(res.msg);
        }
      });
  }

  async created() {
    this.$route.params.riskLevel && (this.searchForm.riskLevel = this.$route.params.riskLevel);
    this.$route.params.areaId && (this.searchForm.areaId = this.$route.params.areaId);
    this.userInfo = JSON.parse((localStorage as any).getItem('userInfo'));
    this.searchForm.spaceArea = this.userInfo.areaId;
    this.getRiskAndDangerList();
    this.getDetailsMapByName(); // 管控层级
    this.getTableData();
    this.getSpaceAreaData(); // 区域列表
  }

  // 区域列表
  getSpaceAreaData() {
    regionServe.getAreaAndSubAreaList({ areaId: this.userInfo.areaId }).then((res: any) => {
      if (res.code === '200') {
        this.spaceAreaList = arrayToTree(res.data);
      } else {
        this.$message.warning('获取区域的列表失败！');
      }
    });
  }

  // 获取风险点和危险源的下拉
  // getRiskData(name: any) {
  getRiskData(e: any) {
    this.riskPointList = [];
    this.searchForm.riskPoint = '';
    this.searchForm.dangerSource = '';
    this.dangerSourceIdList = [];
    this.helpDangerSourceIdList = [];
    if (e) {
      this.getRiskAndDangerList();
    }
  }
  private getRiskAndDangerList() {
    doublePrevention
      .getRiskAll({
        areaId: this.searchForm.spaceArea,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.riskPointList = res.data.filter((item: any) => item.type === '风险点');
          this.helpDangerSourceIdList = res.data.filter((item: any) => item.type === '危险源');
        } else {
          this.$message.warning('获取风险点和危险源的数据失败！');
        }
      });
  }

  // 通过所选的风险点获取危险源的下拉
  private getDangerSourceIdList(e: any) {
    this.searchForm.dangerSource = '';
    this.dangerSourceIdList = this.helpDangerSourceIdList.filter((item: any) => item.pid === e);
  }

  // 管控层级的下拉
  getDetailsMapByName() {
    dictServe.getDetailsMapByName('controlHierarchy').then((res: any) => {
      if (res.code === '200') {
        const helpArr: any = [];
        for (const key in res.data) {
          helpArr.push({
            value: key,
            label: res.data[key],
          });
        }
        this.controlHierarchyList = helpArr;
      } else {
        this.$message.warning(res.msg);
      }
    });
  }

  // 风险点变化时，清空危险源的值
  @Watch('searchForm.riskPoint')
  watchRiskPoint(newData: any, oldData: any) {
    if (oldData) {
      this.searchForm.dangerSource = '';
    }
  }

  private downloadTemplate() {
    window.location.href = publishObjectPath.imgPathWater + `/doc/风险分级管控清单-风险.xlsx`;
  }

  private handleAvatarCardFrontSuccess(file: any) {
    if (file.code === '200') {
      (this.$refs.ImportDialogDataRef as any).showDialog(file.data);
    } else {
      this.$message.warning(file.msg);
    }
    this.fileList = [];
  }

  private handleRemove(file: any, fileList: any) {
    this.fileList = fileList;
  }

  importResponse() {
    this.getTableData();
  }

  mounted() {
    this.headers.Authorization = localStorage.getItem('token');
  }

  private handleSelectionChange(val: any) {
    this.selectedData = val;
  }

  exportTableData() {
    this.$confirm(`导出数据是否继续？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    })
      .then(() => {
        this.exportOperateApi();
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消',
        });
      });
  }

  exportOperateApi() {
    const loading = this.$loading({
      lock: true,
      text: '下载中...',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)',
    });
    Axios.defaults.headers['content-type'] = 'application/json;charset=UTF-8';
    Axios.defaults.headers.Authorization = localStorage.getItem('token');
    const arrId: any = this.selectedData.map((item: any) => item.id);

    Axios({
      method: 'POST',
      url: publishObjectPath.serverUrl + '/api/yunnan/riskControlInventory/canBeImported/export/excel', // 请求地址
      responseType: 'blob', // 表明返回服务器返回的数据类型
      data: {
        areaId: this.searchForm.spaceArea ? this.searchForm.spaceArea : null, // 区域
        controlHierarchy: this.searchForm.controlHierarchy ? this.searchForm.controlHierarchy : null, // 管控层级
        dangerSourceId: this.searchForm.dangerSource ? this.searchForm.dangerSource : null, // 危险源
        riskLevel: this.searchForm.riskLevel ? this.searchForm.riskLevel : null, // 风险等级
        riskPointId: this.searchForm.riskPoint ? this.searchForm.riskPoint : null, // 风险点
        riskTypeTagName: this.searchForm.riskTypeTagName ? this.searchForm.riskTypeTagName : null, // 风险类型
        search: this.searchForm.search ? this.searchForm.search : null, // 关键字搜索
        selectIdList: arrId && arrId.length ? arrId : null,
        /*// current: this.queryDataForm.pageNo,
          // size: this.queryDataForm.pageSize,
          riskTypeTagName: this.searchForm.riskTypeTagName ? this.searchForm.riskTypeTagName : null, // 风险类型
          controlHierarchy: this.searchForm.controlHierarchy ? this.searchForm.controlHierarchy : null, // 管控层级
          dangerSourceId: this.searchForm.dangerSource ? this.searchForm.dangerSource : null, // 危险源
          riskPointId: this.searchForm.riskPoint ? this.searchForm.riskPoint : null, // 风险点
          // areaId: this.searchForm.spaceArea ? this.searchForm.spaceArea[this.searchForm.spaceArea.length - 1] : null, // 区域
          areaId: this.searchForm.spaceArea ? this.searchForm.spaceArea : null, // 区域
          riskLevel: this.searchForm.riskLevel ? this.searchForm.riskLevel : null, // 风险等级
          search: this.searchForm.search ? this.searchForm.search : null, // 关键字搜索
          selectIdList: arrId && arrId.length ? arrId : null,*/
      },
    })
      .then((response: any) => {
        // const disposition = response.headers["Content-disposition"];
        console.log(response);
        let fileName = '导出文件';
        try {
          const disposition = response.headers['content-disposition'];
          console.log(disposition);
          fileName = decodeURIComponent(disposition.split('filename = ')[1]); // 中文需要转码 (前端乱码为百分号形式）
        } catch (error) {
          fileName = '导出文件';
        }
        const blob = response.data;
        const a = document.createElement('a');
        a.download = fileName;
        a.style.display = 'none';
        a.href = URL.createObjectURL(blob);
        document.body.appendChild(a); // 修复firefox中无法触发click
        a.click();
        document.body.removeChild(a);
        loading.close();
        this.$message.success('导出成功!');
      })
      .catch((error: any) => {
        console.log(error, 'error');
        loading.close();
        this.$message.error('导出失败,请联系管理员!');
      });
  }
}
